import useSocketAuthorization from './hooks/useSocketAuthorization'

export default function SocketProvider() {
  useSocketAuthorization()

  return null
}
